"use client";

import { Activity, ShieldCheck, UserCheck, Clock, Award } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Long-Term Recovery",
  description: "Focusing on sustainable healing and root-cause treatment, not just quick fixes.",
  icon: Activity
}, {
  title: "Private Environment",
  description: "1-on-1 sessions conducted in fully private, comfortable treatment rooms.",
  icon: ShieldCheck
}, {
  title: "Expert Therapists",
  description: "Highly qualified professionals dedicated to your personalised care plan.",
  icon: UserCheck
}, {
  title: "Flexible Scheduling",
  description: "Convenient appointment times designed to fit seamlessly into your busy lifestyle.",
  icon: Clock
}, {
  title: "Evidence-Based",
  description: "Utilising the latest clinical research and techniques for optimal outcomes.",
  icon: Award
}];
export default function WhyChooseAlignPhysiotherapy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="why-choose-align-physiotherapy" className="bg-background">
      <div className="bg-secondary py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-6">
          <div ref={ref} className={`text-center max-w-3xl mx-auto mb-12 md:mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
              Why Choose Align Physiotherapy
            </h2>
            <p className="text-muted-foreground text-lg">
              Experience a higher standard of care in a premium clinic setting designed for your complete recovery.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {features.map((feature, i) => {
            const Icon = feature.icon;
            return <div key={i} data-index={i} className={`transition-all duration-500 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
              transitionDelay: `${i * 100}ms`
            }}>
                  <Card className="h-full rounded-lg shadow-soft border-none bg-background hover-lift">
                    <CardHeader className="pb-2">
                      <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-md bg-primary/10 text-primary">
                        <Icon className="size-6" strokeWidth={2} />
                      </div>
                      <CardTitle className="text-lg font-semibold text-foreground">
                        {feature.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {feature.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}